import { render, staticRenderFns } from "./NearbyBenchmarks.vue?vue&type=template&id=0bac7608&scoped=true"
import script from "./NearbyBenchmarks.vue?vue&type=script&lang=js"
export * from "./NearbyBenchmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bac7608",
  null
  
)

export default component.exports